export default "__VITE_ASSET__0851e74f__"